<template>
  <div>
    <v-btn
      color="#F3843C"
      v-if="operation === 'create'"
      @click="createSubmit"
      dark
      class="mr-16 text-body-2"
    >Salvar
    </v-btn>

    <v-btn
      color="#F3843C"
      v-else
      @click.once="updateSubmit"
      dark
      class="mr-16 text-body-2"
    >Atualizar
    </v-btn>
    <v-btn
      color="#F3843C"
      outlined
      class="text-body-2"
      @click.stop="cancelar(false)"
      dark
    >Cancelar
    </v-btn>
  </div>
</template>

<script>
 export default {
  name: "ButtonsFormSide",
  props:{
   operation:{
    type:String,
    required:true
   }
 },
  methods:{
   cancelar(value){
    this.$emit('cancel',value)
   },
   createSubmit(){
    this.$emit('onCreateSubmit')
   },
   updateSubmit(){
    this.$emit('onUpdateSubmit')
   }
  }
 }
</script>

<style scoped>

</style>